import { ref } from "vue";

export const store = ref([])